import React from 'react'

import EtcPage from 'Components/EtcPage/EtcPage'

export default function Teacher() {
  return <EtcPage content="선생님 페이지입니다." />
}
